import { createContext, useContext, useMemo, useState } from "react";
import { ScreenId } from "./screens/types";

const NavigateContext = createContext<{
  onNavigate: (id: ScreenId) => void;
  onGoBack: () => void;
}>({
  onNavigate: () => {
    throw new Error("ScreenProvider not initialized");
  },
  onGoBack: () => {
    throw new Error("ScreenProvider not initialized");
  },
});

export const useNavigate = () => {
  const context = useContext(NavigateContext);
  return context;
};

const ScreenContext = createContext<ScreenId>("selectMode");

export const useScreen = () => {
  const context = useContext(ScreenContext);
  return context;
};

const HistoryContext = createContext<ScreenId[]>([]);

export const useHistory = () => {
  const context = useContext(HistoryContext);
  return context;
};

export interface ScreenProviderProps {
  children: React.ReactNode;
  firstScreenId: ScreenId;
}

export const ScreenProvider = ({
  children,
  firstScreenId,
}: ScreenProviderProps) => {
  const [history, setHistory] = useState<ScreenId[]>([firstScreenId]);

  const navigate = useMemo(() => {
    return {
      onNavigate: (id: ScreenId) => {
        setHistory((history) => [id, ...history]);
      },
      onGoBack: () => {
        setHistory((history) => {
          if (history.length === 1) {
            return history;
          }
          const [_current, ...prev] = history;
          return prev;
        });
      },
    };
  }, []);

  return (
    <NavigateContext.Provider value={navigate}>
      <HistoryContext.Provider value={history}>
        <ScreenContext.Provider value={history[0]}>
          {children}
        </ScreenContext.Provider>
      </HistoryContext.Provider>
    </NavigateContext.Provider>
  );
};
